import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';

export function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: Location })?.from?.pathname || '/dashboard';

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, from]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex items-center justify-center">
            <img
              src="/egpa-logo.png"
              alt="eGPA"
              className="h-16 w-auto"
            />
          </div>
          <CardTitle className="text-2xl">eGPA</CardTitle>
          <CardDescription>
            Elektronische Gefangenenpersonalakte
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-sm text-muted-foreground">
            Bitte melden Sie sich mit Ihrem Dienstkonto an, um auf das System
            zuzugreifen.
          </p>
          <Button
            onClick={login}
            className="w-full"
            size="lg"
            disabled={isLoading}
          >
            {isLoading ? 'Lädt...' : 'Anmelden'}
          </Button>
          <p className="text-center text-xs text-muted-foreground">
            Der Zugriff wird protokolliert und ist nur für autorisierte
            Mitarbeiter gestattet.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
